window.loadCkeditor5 = (() => {
    let scriptLoadPromise = null;

    return function () {
        if (document.getElementById('ckeditor5-script')) {
            return scriptLoadPromise || Promise.resolve();
        }

        document.head.appendChild(Object.assign(document.createElement('link'), {
            rel: 'stylesheet',
            href: '/build/assets/static/ckeditor5/ckeditor5.css',
            id: 'ckeditor5-style',
            type: 'text/css'
        }));

        scriptLoadPromise = new Promise((resolve, reject) => {
            const script = Object.assign(document.createElement('script'), {
                src: '/build/assets/static/ckeditor5/ckeditor5.umd.js',
                id: 'ckeditor5-script',
                onload: resolve,
                onerror: reject,
            });

            document.head.appendChild(script);
        });

        return scriptLoadPromise;
    };
})();
